import { createDraftSafeSelector } from "@reduxjs/toolkit"
import { RootState } from "../store"
import { HoldingsState } from "../reducer/holdings.reducer"

const userState = (state: RootState) => state.holdingsStore as HoldingsState

export const selectHoldings = createDraftSafeSelector(userState, (store) => store.holdings)
export const selectHoldingsLoading = createDraftSafeSelector(userState, (store) => store.loading)
export const selectHoldingsPrevTradingAccount = createDraftSafeSelector(userState, (store) => store.prevTradingAccountId)